import { useSearchParams } from 'react-router';
import { useCallback } from 'react';

export function useSearchParamState() {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleFilterChange = useCallback(
    (...filters: { filterType: string; value?: string | boolean | number }[]) => {
      const newSearchParams = new URLSearchParams(searchParams);
      filters.forEach(({ filterType, value }) => {
        if (value) {
          newSearchParams.set(filterType, value + '');
        } else {
          newSearchParams.delete(filterType);
        }
      });

      setSearchParams(newSearchParams);
    },
    [searchParams, setSearchParams]
  );

  return {
    searchParams,
    setSearchParams,
    handleFilterChange,
  };
}
